import { render, staticRenderFns } from "./course-list.vue?vue&type=template&id=4bff6760&scoped=true"
import script from "./course-list.vue?vue&type=script&lang=js"
export * from "./course-list.vue?vue&type=script&lang=js"
import style0 from "./course-list.vue?vue&type=style&index=0&id=4bff6760&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bff6760",
  null
  
)

export default component.exports